const useInvalidateCacheTagsDispatcher = () => {
  const dispatchInvalidateCacheTagsEvent = (tags) => {
    let tagsArray;

    if (!Array.isArray(tags)) {
      tagsArray = [tags];
    } else {
      tagsArray = tags;
    }

    window.dispatchEvent(
      new CustomEvent('invalidateTags', { detail: { tags: tagsArray } }),
    );
  };

  return { dispatchInvalidateCacheTagsEvent };
};

export default useInvalidateCacheTagsDispatcher;
